import { render, staticRenderFns } from "./MultiSlideSlider.vue?vue&type=template&id=072f8840&"
import script from "./MultiSlideSlider.vue?vue&type=script&lang=js&"
export * from "./MultiSlideSlider.vue?vue&type=script&lang=js&"
import style0 from "./MultiSlideSlider.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('072f8840')) {
      api.createRecord('072f8840', component.options)
    } else {
      api.reload('072f8840', component.options)
    }
    module.hot.accept("./MultiSlideSlider.vue?vue&type=template&id=072f8840&", function () {
      api.rerender('072f8840', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/sliders/MultiSlideSlider.vue"
export default component.exports